import { window } from 'ssr-window'

const KDevice = {}

KDevice.pixelRatio = window.devicePixelRatio || 1

KDevice.isRetina = KDevice.pixelRatio > 1

const Sys = {}
const ua = navigator.userAgent.toLowerCase()
/* eslint-disable */
let s
(s = ua.match(/edge\/([\d.]+)/)) ? Sys.edge = s[1]
  : (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1]
  : (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1]
    : (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1]
      : (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1]
        : (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1]
          : (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0
/* eslint-enable */

KDevice.sys = Sys
// KDevice.noAnim = !!Sys.ie
KDevice.noAnim = false

export default KDevice
